import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FeedbackForm from '../../components/FeedbackForm/FeedbackForm';
import PurchaseForm from '../../components/PurchaseForm/PurchaseForm';

const Customer = () => {
  const [hasPurchased, setHasPurchased] = useState(null);
  const {sessionActive} = useSelector((state) => state.userSessionData);
   const navigate = useNavigate();

  useEffect(() => {
      if(!sessionActive){
          navigate('/');
      }
  }, [sessionActive]);

  useEffect(() => {
    const purchaseQuestion = localStorage.getItem('hasPurchased');
    setHasPurchased(purchaseQuestion);
  }, []);

  if (hasPurchased === 'yes') {
    return <PurchaseForm />;
  }

  if (hasPurchased === 'no') {
      return <FeedbackForm />;
  }

  return <div>Loading...</div>;
}

export default Customer
